import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import VideoEditor from './components/VideoEditor';
import '../src/assets/css/custom.css'
import { Routes, Route } from "react-router-dom";
import { MergeVideo } from './components/MergeVideo';
import { AddText } from './components/AddText';
import { AddAudio } from './components/AddAudio';
import { NavBar } from './components/NavBar';
import { ExtractAudio } from './components/ExtractAudio';
import { TrimVideo } from './components/TrimVideo';
import { AllInOne } from './components/AllInOne';





function App() {

  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" index  element={<VideoEditor/>} />
        <Route path="merge-video" element={<MergeVideo />} />
        <Route path="add-text" element={<AddText />} />
        <Route path="add-audio" element={<AddAudio />} />
        <Route path="extract-audio" element={<ExtractAudio />} />
        <Route path="trim-video" element={<TrimVideo />} />
        {/* <Route path="brightness-video" element={<BrigthnessVideo />} /> */}
        <Route path="all-in-one" element={<AllInOne />} />

      </Routes>
    </>
  );
}

export default App;
